import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { SupplierConverter, jsonConversions } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CRUTransportLayer } from '../CRUTransportLayer';
import { CONSTANTS } from '../../../constants';
import logger from '../../logger';
import api from '../../api';
export var SupplierLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(SupplierLayer, _CRUTransportLayer);

  function SupplierLayer() {
    _classCallCheck(this, SupplierLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierLayer).call(this, CONSTANTS.API.ENDPOINTS.SUPPLIERS));
  }

  _createClass(SupplierLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.supplierConverter;
    }
    /**
     * Find suppliers by specified filter
     * @param filter
     */

  }, {
    key: "filter",
    value: function filter(_filter) {
      var _this = this;

      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.SUPPLIERS_FILTER).post(_filter, apiConfig).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.supplierConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return SupplierLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", SupplierConverter)], SupplierLayer.prototype, "supplierConverter", void 0);